import type { Theme } from './chat/theme';

/**
 * Light/dark toggle, shared by the chat and admin app bars. A pressed button
 * means dark. The glyph is one half-filled circle in both themes: it is drawn
 * in --app-fg, which inverts with the theme, so the filled half reads light in
 * dark and dark in light, and the circle appears to flip. Swapping to the
 * mirrored glyph as well would cancel that out and look unchanged.
 */
export function ThemeToggle({ value, onChange }: { value: Theme; onChange: (t: Theme) => void }) {
  const dark = value === 'dark';
  return (
    <button
      type="button"
      className="app__btn app__theme-toggle"
      aria-label="Dark theme"
      aria-pressed={dark}
      title={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => onChange(dark ? 'light' : 'dark')}
    >
      <span aria-hidden="true">◐</span>
    </button>
  );
}
